import { createContext, useState, useMemo } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);
    const [addTrigger, setAddTrigger] = useState(0); // Trigger for animation

    // Derive cartCount from cartItems length - no need for separate state
    const cartCount = useMemo(() => cartItems.length, [cartItems]);

    const addToCart = (item) => {
        // Always trigger animation
        setAddTrigger((prev) => prev + 1);

        setCartItems((prev) => {
            const existingItem = prev.find((i) => i.id === item.id);
            if (existingItem) {
                // Item already exists - don't add again
                return prev;
            }
            // New item - add to cart
            return [...prev, { ...item, quantity: 1 }];
        });
    };

    const removeFromCart = (itemId) => {
        setCartItems((prev) => prev.filter((i) => i.id !== itemId));
    };

    const clearCart = () => {
        setCartItems([]);
    };

    return (
        <CartContext.Provider
            value={{
                cartItems,
                cartCount,
                addTrigger,
                addToCart,
                removeFromCart,
                clearCart,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};
